import { render } from "./AddOrEditMOCType.vue?vue&type=template&id=9b3a8cf0"
import script from "./AddOrEditMOCType.vue?vue&type=script&lang=js"
export * from "./AddOrEditMOCType.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__